import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Nav, Tab } from "react-bootstrap";
import { useSelector } from "react-redux";
import axios from "axios";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import moment from "moment";
import Analytics from "./feedbacksurveycomp/Analytics";
import FeedBackList from "./feedbacksurveycomp/FeedBackList";
import CreateFeedback from "./feedbacksurveycomp/CreateFeedback";
import FilterDateRange from "./feedbacksurveycomp/FilterDates/FilterDateRange";
import Alldatafilter from "./feedbacksurveycomp/FilterDates/DateRangeSelector";
import { exportMultipleChartsToPdf } from "../../utils/pdf";
import ProPopup from "../../pages/ProPopup";
import { CreateNewIcon } from "./../../assets/Icons";
import { UnoStoreHooks, UiComponents } from "@simulanisindia/ui";
import { BackArrowIcon, CircleLoading, DownloadIcon } from "../../Icons";
import apiClient from "../../apiClient";
const { useUnoSelector } = UnoStoreHooks;
const { BackButton, NormalGradientButton } = UiComponents;
const Feedback = () => {
  const configData = useUnoSelector((state) => state.config);
  const userData = useUnoSelector((state) => state.user);

  const location = useLocation();
  const { state } = location;
  const [activeTabAnalytics, setActiveTabAnalytics] = useState("analytics");
  const [filter, setFilter] = useState("all");
  const [showFilter, setShowFilter] = useState(false);
  const [show, setShow] = useState(false);
  const [analyticsData, setAnalyticsData] = useState({});
  const [dateRange, setDateRange] = useState("all");
  const [loading, setLoading] = useState(true);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [pdfDownload, setPdfDownload] = useState(false);
  const [openPro, setOpenPro] = useState(false);
  const [userPlan, setUserPlan] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (userData?.plans?.data) setUserPlan(userData.plans.data);
  }, [userData]);

  const getAnalytics = async (req, res) => {
    try {
      setPdfDownload(true);

      let data = await apiClient.get(`${configData.config.UNO_URL}/api/feedback/feedbackAnalytics/${filter}`)

      // const { data } = await axios.get(`${configData.config.UNO_URL}/api/feedback/feedbackAnalytics/${filter}`, {
      //   headers: {
      //     Authorization: `Bearer ${userData.token}`,
      //   },
      // });

      setAnalyticsData(data || {});
      setLoading(false);
    } catch (error) {
      console.log(error);
    } finally {
      setPdfDownload(false);
    }
  };
  // const handleClickDownload = async () => {
  //   try {
  //     setPdfDownload(true);
  //     if (activeTab === USER_TAB_TYPE) {
  //       let { list } = await apiClient.get(`${configData.config.UNO_URL}${GROUP_USERS_LIST}/${UUID}`);
  //       const tableData = list.map((user, index) => [
  //         index + 1,
  //         user.name,
  //         user.email,
  //         user.uid,
  //         user.phone,
  //         user.designation,
  //         user.roleAllocations.find((e) => e.role.type !== "DEFAULT")?.role.name || user.roleAllocations[0]?.role.name,
  //       ]);

  //       await downloadExcel({
  //         name: "Users list",
  //         header: userPdfHeader,
  //         tableData,
  //       });

  //       // await downloadPdf({
  //       //   mode: "landscape",
  //       //   groupName: groupDetails.name,
  //       //   heading: "Users list",
  //       //   header: userPdfHeader,
  //       //   tableData: tableData,
  //       // });
  //     } else if (activeTab === GROUP_TAB_TYPE) {
  //       let { list } = await apiClient.get(`${configData.config.UNO_URL}${GROUP_LIST}/${UUID}`);
  //       const tableData = list.map((group, index) => [index + 1, group.name, group.role, group.groups, group.users]);

  //       // await downloadPdf({
  //       //   heading: "Groups list",
  //       //   groupName: groupDetails.name,
  //       //   header: groupPdfHeader,
  //       //   tableData: tableData,
  //       // });

  //       await downloadExcel({
  //         name: "Groups list",
  //         header: groupPdfHeader,
  //         tableData,
  //       });
  //     }
  //   } catch (error) {
  //   } finally {
  //     setPdfDownload(false);
  //   }
  // };

  useEffect(() => {
    getAnalytics();
  }, [filter]);

  useEffect(() => {
    if (state?.key) {
      setActiveTabAnalytics(state.key);
    }
  }, []);

  const handleTabChange = (tab) => {
    setActiveTabAnalytics(tab);
  };

  const DateRangeOpen = () => {
    setShowFilter(!showFilter);
  };

  const tableData = [
    ["Feedback and Management Survey Report", ""],
    ["Name", userData?.user?.name],
    ["Report Created at ", moment().format("ll")],
  ];
  const backClick = () => {
    navigate(-1);
  };

  return (
    <>
      <div className="parents-container">
        <div className="page-title with-fuctions">
          <BackButton onBackClick={backClick} Icon={<BackArrowIcon />} />
          <h6>Feedback & Survey</h6>
        </div>

        <Tab.Container id="nested-tabs" activeKey={activeTabAnalytics} onSelect={handleTabChange}>
          <div className="title-mini ">
            <div className="nav-option">
              <Nav className=" tabfull tabsproduct" variant="pills">
                <Nav.Item>
                  <Nav.Link eventKey="analytics">Analytics</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="feedbacklist">Feedback & Survey List</Nav.Link>
                </Nav.Item>
              </Nav>
            </div>
            {!loading && (
              <div className="csvuploaddownload d-flex align-items-center gap-2 h-100">
                {activeTabAnalytics === "analytics" && (
                  <>
                    <Alldatafilter selected={filter} setSelected={setFilter} />
                    <div>
                      <button
                        type="button"
                        onClick={() => exportMultipleChartsToPdf(tableData)}
                        className="uloadoanload"
                      >
                        <BackButton
                          Icon={
                            pdfDownload ? (
                              <span className="loading-down">
                                {" "}
                                <CircleLoading />{" "}
                              </span>
                            ) : (
                              <DownloadIcon />
                            )
                          }
                        />
                      </button>
                    </div>
                  </>
                )}
                {/* <div className="m-0 gap-2">
                  <button className="normalbtn pro gap-2 " onClick={handleShow}>
                    <CreateNewIcon /> {" "}<p className='m-0'>  </p>
                  </button>
                </div> */}

                <NormalGradientButton icon={<CreateNewIcon />} text="Create New" onClick={handleShow} />
              </div>
            )}
          </div>
          <Tab.Content>
            <Tab.Pane eventKey="analytics">
              <Analytics loading={loading} analyticsData={analyticsData} />
            </Tab.Pane>

            <Tab.Pane eventKey="feedbacklist">
              <FeedBackList />
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>

        <CreateFeedback show={show} handleClose={handleClose} />

        {showFilter && (
          <>
            <div onClick={DateRangeOpen} className="overlaydf" />
            <FilterDateRange />
          </>
        )}

        <ProPopup openPro={openPro} setOpenPro={setOpenPro} />
      </div>
    </>
  );
};

export default Feedback;
